import { createSelector } from 'reselect';
import { AppState } from '../reducers';

const termsOfServiceSelector = (state: AppState) => state.termsOfService;

export const isTermsOfServiceAcceptedSelector = createSelector(termsOfServiceSelector, (termsOfService) => {
  return termsOfService.accepted || Object.values(termsOfService.byId).some((t) => t.accepted);
});
